var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagMadeira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9565 1.58763C20.853 0.5705 18.4932 0 16 0C13.5068 0 11.147 0.5705 9.04347 1.58763L7.65216 16L9.04347 30.4124C11.147 31.4295 13.5068 32 16 32C18.4932 32 20.853 31.4295 22.9565 30.4124L24.3478 16L22.9565 1.58763Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0435 1.58813C3.69156 4.17607 0 9.65664 0 15.9999C0 22.3433 3.69156 27.8238 9.0435 30.4118V1.58813Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9561 1.58813V30.4118C28.3079 27.8238 31.9996 22.3433 31.9996 15.9999C31.9996 9.65664 28.3079 4.17607 22.9561 1.58813Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5218 17.3913L21.5652 18.7826V13.2174L20.5218 14.6087H17.3913V11.4783L18.7826 10.4348H13.2174L14.6087 11.4783V14.6087H11.4783L10.4348 13.2174V18.7826L11.4783 17.3913H14.6087V20.5218L13.2174 21.5652H18.7826L17.3913 20.5218V17.3913H20.5218Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1739 15.3045H16.6956V11.8262H15.3044V15.3045H11.826V16.6957H15.3044V20.174H16.6956V16.6957H20.1739V15.3045Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMadeira);
export default __webpack_public_path__ + "static/media/flag_madeira.fd5079d064c77e050b848d5ca92ebfdf.svg";
export { ForwardRef as ReactComponent };